
<mat-progress-bar
  mode="indeterminate"
  *ngIf="isLoading"
  color="accent">
</mat-progress-bar>
